<!--订单查看-->
<template>
  <div>
    <app-breadcrumb/>
    <div class="page-container view-orderquery">
      <el-form v-loading="listLoading" :model="viewObj" label-width="110px" size="mini">
        <!--      基本信息-->
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <!--    订单编号  -->
        <el-form-item :label="$t('poOrder.orderNo')+':'">
          {{ viewObj.orderNo }}
        </el-form-item>
        <!--      会员编号-->
        <el-form-item :label="$t('poOrder.memberNo')+':'">
          {{ viewObj.memberNo }}
        </el-form-item>
        <!--      单据类型-->
        <el-form-item :label="$t('fiAcInput.orderType')+':'">
          {{ $lt('po.allordertype.cn', viewObj.orderType) }}
        </el-form-item>
        <!--      收货方式-->
        <el-form-item :label="$t('PoOrder.recType')+':'">
          <!-- 从专卖店提货 -->
          <span v-show="viewObj.recType===1">{{ $t('pick.up.from.franchise') }}</span>
          <!-- 从分公司提货 -->
          <span v-show="viewObj.recType===2">{{ $t('pick.up.from.branch.office') }}</span>
          <span v-show="viewObj.recType===3">{{ $t('send.by.post') }}</span>
        </el-form-item>
        <!--      收货人姓名-->
        <el-form-item :label="$t('PoOrder.recName')+':'">
          {{ viewObj.recName }}
        </el-form-item>
        <!--      联系电话-->
        <el-form-item :label="$t('sysCompany.phone')+':'">
          {{ viewObj.recPhone }}
        </el-form-item>
        <!--      收货地址-->
<!--        <el-form-item :label="$t('ssCustomer.saddress')+':'">-->
<!--          {{ viewObj.posendCompany.length ? viewObj.posendCompany[1].country : '' }}-->
<!--          {{ viewObj.posendCompany.length ? viewObj.posendCompany[0].province : '' }}-->
<!--          {{ viewObj.recAddr }}-->
<!--        </el-form-item>-->
        <!--      创建时间-->
        <el-form-item :label="$t('Common.createTime')+':'">
          {{ viewObj.createTime }}
        </el-form-item>
        <!--      审核时间-->
        <el-form-item :label="$t('pmProductSppm.checkDate')+':'">
          {{ viewObj.checkTime }}
        </el-form-item>
        <!--      状态-->
        <el-form-item :label="$t('fiBankbookTemp.status')+':'">
          {{ $lt(this.initDict.status, viewObj.status) }}
        </el-form-item>
        <!--      付款方式-->
        <h3 style="color: #b3640d">{{ $t('fiPayAdvice.dealType') }}</h3>
        <!--      商品总金额-->
        <el-form-item v-if="viewObj.orderType != 27" :label="$t('poAssistMemberOrder.productAmount')+':'">
          {{ viewObj.totalAmount }}
        </el-form-item>
        <!--      PV-->
        <el-form-item v-if="viewObj.orderType != 27" :label="$t('FV')+':'">
          {{ viewObj.totalFv }}
        </el-form-item>
        <el-form-item v-if="viewObj.orderType == 27 || viewObj.orderType ==35" :label="$t('BiGoods.proPv')+':'">
          {{ viewObj.totalpointa0 }}
        </el-form-item>
        <!--      合计-->
        <el-form-item  v-if="viewObj.orderType != 27" :label="$t('bdSendEfuboBonusDetail.amtCount')+':'">
          {{ viewObj.totalAmount }}
        </el-form-item>
        <!--      付款方式-->
        <el-form-item :label="$t('fiPayAdvice.dealType')+':'">
          {{ $lt(this.initDict.payment, viewObj.paymentMethod) }}
        </el-form-item>
        <!--      商品清单-->
        <h3 style="color: #b3640d">{{ $t('busi.goods.list') }}</h3>
        <el-table
            :key="tableKey"
            :data="list"
            border
            size="mini"
            fit
            highlight-current-row
            style="width: 100%;"
        >
          <!--    商品编号  -->
          <el-table-column :label="$t('pmProductList.productId')" prop="goodsCode" align="center"/>
          <el-table-column :label="$t('BiGoods.goodsCode.old')" prop="oldCode" align="center"/>
<!--          -->
          <el-table-column :label="$t('BiGoods.name')" prop="name" align="center"/>
          <!--      商品名称-->
          <!--      进号单价-->
          <el-table-column :label="$t('po.field.price')" prop="f$" align="center"/>
          <!--      订购数量-->
          <el-table-column :label="$t('poOrder.count')" prop="quantity" align="center"/>
          <!--      单品总金额-->
          <el-table-column :label="$t('bigoods.pergoods.total')" prop="" align="center">
            <template v-slot="{row}">
              {{ row.f$ * row.quantity }}
            </template>
          </el-table-column>
          <!--      是否赠品-->
          <el-table-column :label="$t('bigoods.send.ornot')" prop="isGive" align="center">
            <template v-slot="{row}">
              <span>{{ $lt(initDict.isGift, row.isGive) }}</span>
            </template>
          </el-table-column>
          <!--      是否赠品    -->
          <el-table-column :label="$t('Is.it.a.physical.point')" prop="productForm" align="center">
            <template v-slot="{row}">
              {{$lt(initDict.physicalpoint,row.productForm)}}
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
          <el-button size="mini" icon="el-icon-close" type="warning" @click="$router.back()">
            {{ $t('operation.button.cancel') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {orderView} from "@/api/ay-business-manager/orderquery";
export default {
  name: "ViewOrderquery",
  data() {
    return {
      viewObj: {
        posendCompany: []
      },
      tableKey: 0,
      listLoading: false,
      list: [],
      viewTd: null,
      initDict: {
        status: 'po.order.status',
        payment: 'po.order.payment.cn',
        physicalpoint:'Is.it.a.physical.point',
        isGift: 'po.order.isgive'
      }
    }
  },
  created() {
    if(this.$route.params.id) {
      this.getView(this.$route.params.id)
    } else {
      this.$message.error(this.$t('Parameter.Not.Exist'))
      this.$router.go(-1)
    }
  },
  methods: {
    getView(val) {
      this.listLoading = true
      orderView({'id': val}).then(res => {
        this.viewObj = res.data
        this.list = res.data.poOrderDetails
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
        this.$router.back()
        console.error(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
